// extracted by mini-css-extract-plugin
export default {"special-offer-header":"res06vz21CFzhNd","special-offer-header-text":"HC0YO6kcTyvMlf4"};